jQuery(function() {
    //initialize slick sliders
    if(jQuery('.hero-background-slide').length > 1) {
        console.log('initializing hero background rotator');
        jQuery('.hero-background-slides').slick({
            infinite: true,
            slidesToShow: 1,
            dots: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 0,
            fade: true,
            cssEase: 'linear'
        });
    }
    if(jQuery('.hero-background-slide').length > 1) {
        console.log('initializing hero background mobile rotator');
        jQuery('.hero-background-slides-mobile').slick({
            infinite: true,
            slidesToShow: 1,
            dots: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 0,
            fade: true,
            cssEase: 'linear'
        });
    }
    
    //set target tags for all on-page links
    jQuery('.page-content a').attr('target', function() {
        if(this.host == location.host) return '_self'
        else return '_blank'
    });
});